// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1__DE","cls2":"WorkSelectorUpload-cls2_KVG WorkSelectorUpload-cls1__DE"};